import {
  READABLE_APP_NAMES,
  SubscriptionInterval,
  TRIAL_BILLING_CYCLE_KEYS,
  TRIAL_DAILY_PERIOD,
  TRIAL_MONTHLY_PERIOD,
  TrialBillingCycle,
} from 'root-constants'

export const getBillingCycleKey = (daysCount: number) => {
  if (
    daysCount < TrialBillingCycle.SEVEN_DAYS ||
    daysCount === TrialBillingCycle.TEN_DAYS
  ) {
    return TRIAL_DAILY_PERIOD
  }

  return TRIAL_BILLING_CYCLE_KEYS[daysCount] || TRIAL_MONTHLY_PERIOD
}

const getContractPeriod = (interval: string, intervalCount: number): string => {
  if (interval === SubscriptionInterval.YEAR) {
    return intervalCount === 1 ? 'annual' : `${intervalCount}-year`
  }

  if (interval === SubscriptionInterval.MONTH) {
    return `${intervalCount}-month`
  }

  return `${intervalCount}-${interval}`
}

export const getContractLabel = (
  appName: string,
  interval?: string,
  intervalCount?: number,
): string => {
  const name = `${READABLE_APP_NAMES[appName]} Premium`

  return interval && intervalCount
    ? `${name} ${getContractPeriod(interval, intervalCount)}`
    : name
}
